<template>
  <div>
    <van-col :span="24" style="text-align: center;">
      采购单详情
    </van-col>
    <van-col v-if="orderInfo" :span="24">
      <base-input v-model="orderInfo.order_date" label="订单时间" readonly />
      <base-input v-model="orderInfo.code" label="订单号" readonly />
      <base-input v-model="orderInfo.orderer" label="供货单位" readonly />
      <base-input v-model="orderInfo.storage_name" label="收货库房" readonly />
      <base-input v-model="orderInfo.estimated_inbound_date" label="到货时间" readonly />
      <base-input v-model="orderInfo.status_name" label="状态" readonly />
      <base-input v-model="orderInfo.approve_status_name" label="审核状态" readonly />
      <van-col v-for="(detail, index) in orderInfo.details" :key="detail.key" :span="24">
        <van-card :num="detail.count" :price="detail.price" :desc="detail.goods_name" :title="'产品' + (index + 1)"
                  thumb="https://img.yzcdn.cn/vant/ipad.jpeg">
          <div slot="tags">
            <van-tag v-if="detail.type_name" plain type="danger">{{ detail.type_name }}</van-tag>
            <van-tag v-if="detail.specs" plain type="primary">{{ detail.specs }}</van-tag>
          </div>
        </van-card>
        <van-col :span="24">
          <base-input-number v-model="detail.amount" label="小计" readonly />
        </van-col>
      </van-col>
      <base-input-number v-model="orderInfo.total_amount" label="合计金额" readonly />
      <base-input-number v-model="orderInfo.dis_amount" label="优惠金额" readonly />
      <base-input-number v-model="orderInfo.payable_amount" label="应付金额" readonly />
      <base-textarea v-model="orderInfo.remark" label="备注" readonly />
      <base-input v-model="orderInfo.emp_name" label="经手人" readonly />
      <base-input v-model="orderInfo.dept_name" label="部门" readonly />
      <base-input v-model="orderInfo.create_name" label="创建人" readonly />
    </van-col>
    <van-col v-if="orderInfo && orderInfo.approve_status === 1 && canOperate" :span="24" style="text-align: center;">
      <base-button type="primary" size="large" @click="handleApproveStatus(2, '同意')">同意</base-button>
      <base-button type="danger" size="large" @click="handleApproveStatus(3, '拒绝')">拒绝</base-button>
    </van-col>
    <init :init-states="initStates" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import { getApproveEmpList } from '@/api/settings/approve-manage'
import { getOrderList, approveOrder } from '@/api/purchase/order'
export default {
  name: 'PurchaseOrderDetail',
  components: { Init },
  data() {
    return {
      orderId: null,
      orderInfo: null,
      showForm: false,
      initStates: [{
        key: 'goods/init'
      }],
      approveEmpList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    canOperate() {
      const approveEmp = this.approveEmpList.find(approveEmp => approveEmp.emp_id === this.userInfo.emp_id)
      return approveEmp && approveEmp.op_type === 1 // 审批人
    }
  },
  created() {
    this.orderId = parseInt(this.$route.query.id)
    if (this.orderId) {
      this.queryApproveEmpList()
      this.query()
    } else {
      this.error('请求参数错误，请您重新进入')
      this.$router.back()
      return
    }
  },
  methods: {
    handleApproveStatus(status, text) {
      this.confirm(`确定<label class="${status === 2 ? 'tip-msg' : 'err-msg'}">${text}</label>此采购单吗？`)
        .then(async() => {
          approveOrder({
            id: this.orderId,
            approve_status: status
          }).then(resp => {
            this.query()
            this.success(resp.msg)
          })
        }).catch(_ => {})
    },
    queryApproveEmpList() {
      getApproveEmpList({
        type: 1 // 采购
      }).then(resp => {
        this.approveEmpList = resp.rows || []
      })
    },
    query() {
      getOrderList({
        id: this.orderId
      }).then(resp => {
        const rows = resp.rows || []
        if (rows.length > 0) {
          this.orderInfo = rows[0]
          this.orderInfo.status_name = this.CONST.PURCHASE_ORDER_STATUS
            .find(status => status.id === this.orderInfo.status).name

          this.orderInfo.approve_status_name = this.CONST.APPROVE_PURCHASE_ORDER_STATUS
            .find(status => status.id === this.orderInfo.approve_status).name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchase/order-detail.vue